<!-- WRAP LAYOUT IF BOXED -->
<div class="container" *ngIf="_boxed; else basicLayoutBlock">
	<ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</div>
<ng-template #basicLayoutBlock>
	<ng-container *ngTemplateOutlet="contentTpl"></ng-container>
</ng-template>
<!-- YOUR LAYOUT CONTENT GOES INSIDE HERE -->
<div class=" row">

	<div class="col-md-12 nav_bar">
		<div class="d-flex">
			<span (click)="toggle()" class="burger web_title"><i class="fal fa-bars"></i></span>

			<span class="main_title mobile_title">
				<img class="mb-1" src="../../../../assets/logo.png">
			</span>
		</div>


		<div class="float-right d-flex">


			<span class="float-right">
				<div ngbDropdown class=" float-right mt-1" (click)="BodyClicked()">
					<div class="d-flex pt-1" ngbDropdownToggle>
						<img class="avatar" [src]="getAvatar()" width="32" height="32">
						<div class="name">{{getUsername()}}</div>
					</div>
					<div ngbDropdownMenu>
						<button ngbDropdownItem routerLink="/profile"><i class="fal fa-user pr-2"></i>Profile</button>

						<button ngbDropdownItem (click)="logout()"><i class="fal fa-arrow-right pr-2"></i>Logout</button>
					</div>

				</div>
			</span>

		</div>

	</div>


</div>

<body>



	<div class="row">
		<div [ngClass]="'toggle-' + togg">

			<div class="login-containers col-md-2">
				<div class="navs">
					<a routerLink="/dashboard" *ngIf="hasPermission('view_dashboard')" routerLinkActive="active" class="nav_name">
						<span class="nav_icons">
							<i routerLinkActive="icon_active" class="fal fa-chart-pie">
							</i>
						</span>Dashboard
					</a>
					<a routerLink="/bookings" *ngIf="hasPermission('view_booking')" routerLinkActive="active" class="nav_name">
						<span class="nav_icons">
							<i routerLinkActive="icon_active" class="fal fa-book">
							</i>
						</span>Bookings
					</a>
					<a routerLink="/tours" *ngIf="hasPermission('view_tour')" routerLinkActive="active" class="nav_name">
						<span class="nav_icons">
							<i routerLinkActive="icon_active" class="fal fa-route">
							</i>
						</span>Tours
					</a>
					<a routerLink="/companies" *ngIf="hasPermission('view_company')" routerLinkActive="active" class="nav_name">
						<span class="nav_icons">
							<i routerLinkActive="icon_active" class="fal fa-building">
							</i>
						</span>Companies
					</a>
					<a routerLink="/reconciliation" *ngIf="hasPermission('view_reports')" routerLinkActive="active" class="nav_name">
						<span class="nav_icons">
							<i routerLinkActive="icon_active" class="fal fa-coin">
							</i>
						</span>Reports
					</a>
					<a routerLink="/scanner" *ngIf="hasPermission('boarding')" routerLinkActive="active" class="nav_name">
						<span class="nav_icons">
							<i routerLinkActive="icon_active" class="fal fa-barcode-read">
							</i>
						</span>Boarding
					</a>
					<a routerLink="/user" *ngIf="hasPermission('view_user')" routerLinkActive="active" class="nav_name">
						<span class="nav_icons">
							<i routerLinkActive="icon_active" class="fal fa-user">
							</i>
						</span>Users
					</a>
					<a routerLink="/accounts" *ngIf="isAccountant || isAdmin" routerLinkActive="active" class="nav_name">
						<span class="nav_icons">
							<i routerLinkActive="icon_active" class="fal fa-user">
							</i>
						</span>Accounts
					</a>

					<a *ngIf="isAdmin" routerLinkActive="active" [matMenuTriggerFor]="menu1" class="nav_name">
						<span class="nav_icons">
							<i routerLinkActive="icon_active" class="fal fa-cog">
							</i>
						</span>Setting
					</a>

					<mat-menu #menu1="matMenu" xPosition="before" yPosition="below" style="width: 100%;">
						<a mat-menu-item routerLink="/settings/pick-up" class="nav_name">Pickup Location</a>
					</mat-menu>

				</div>
			</div>

		</div>
	</div>



	<div class="box" (click)="BodyClicked()">
		<router-outlet>
			<alert></alert>
		</router-outlet>

	</div>



</body>
